import _taggedTemplateLiteral from "/home/opc/is-monorepo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import gql from 'graphql-tag';
export const getTasksProductsQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query GetTasksProducts($id: Int) {\n    taskProducts(id: $id) {\n      id\n      rastQuantity\n      rastOperator\n      product {\n        id\n        code\n        name\n        barcode\n      }\n    }\n  }\n"])));
export const getTasksProductsQueryOptions = id => ({
  variables: {
    id
  },
  fetchPolicy: 'no-cache',
  notifyOnNetworkStatusChange: true
});
export const getAllTasksProductsQuery = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query GetAllTasksProducts {\n    allTaskProducts{\n      id\n      rastQuantity\n      rastOperator\n      taskIDs\n      product {\n        id\n        code\n        name\n        barcode\n      }\n    }\n  }\n"])));